import { render } from "./UserMessage.vue?vue&type=template&id=8819a3f2"
import script from "./UserMessage.vue?vue&type=script&lang=js"
export * from "./UserMessage.vue?vue&type=script&lang=js"

import "./UserMessage.vue?vue&type=style&index=0&id=8819a3f2&lang=scss"
script.render = render

export default script